import { Field, FieldProps } from 'formik';
import { UserRole } from '@synergy/models';

import { ContactDetailPermissionsRoleCard } from './contact-detail-permissions-role-card';
import { contactPermissionsHasUserSelector } from '../store/contact-detail-permissions-selectors';
import { useAppSelector } from '../../../../../../store/use-appstate-selector';

interface ContactDetailPermissionsRoleFieldProps {
    role: UserRole;
}

export const ContactDetailPermissionsRoleField = (props: ContactDetailPermissionsRoleFieldProps) => {
    const hasUser = useAppSelector(contactPermissionsHasUserSelector);
    const { role } = props;

    return (
        <Field name={`roles.${role}`}>
            {({ field, form }: FieldProps<boolean>) => (
                <ContactDetailPermissionsRoleCard
                    {...field}
                    role={role}
                    disabled={!hasUser && !(form.values.email && form.values.password)}
                />
            )}
        </Field>
    );
};
